import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import { AppWrapper, AppWrapperHeading } from 'components';

import SignupCouponBuilder from './SignupCouponBuilder';
import { useNavigate } from 'react-router-dom';

const HEADER_HEIGHT = 84;

const SignupCouponBuilderWrapper = ({ user, history }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('cbv2-offset-header');
    document.body.style.setProperty('--cbv2-header-h', `${HEADER_HEIGHT}px`);
    return () => {
      document.body.classList.remove('cbv2-offset-header');
      document.body.style.removeProperty('--cbv2-header-h');
    };
  }, []);

  return (
    <AppWrapper
      showHeader
      showSideNav={false}
      showHeadingRow
      headingRowRender={() => (
        <div className="d-flex justify-content-between align-items-center w-100">
          <AppWrapperHeading headingText="Create Your First Coupon" />
        </div>
      )}
    >
      <div className="container-fluid">
        <SignupCouponBuilder
          entryPoint="B"
          history={history}
          onRequireAuth={() => navigate('/signup/form')}
          onGoToFullBuilder={() => navigate('/coupon-builder')}
        />
      </div>
    </AppWrapper>
  );
};

const mapStateToProps = state => ({
  user:
    state.businessInfo?.data ||
    state.auth?.data?.user ||
    state.auth?.user ||
    null,
});

export default connect(mapStateToProps)(SignupCouponBuilderWrapper);
